import { Subject } from 'rxjs';
import { Gizmo } from '../../gizmos';
import { IGizmoData, ILocationData, TGizmoData } from '../../types';
import CommonBinder from '../common-binder';

class LocationFieldBinder extends CommonBinder {
  public locations: Subject<ILocationData[]>;

  constructor(gizmo: Gizmo) {
    super(gizmo);

    this.locations = new Subject<ILocationData[]>();
    this._gizmo.data.subscribe((data: TGizmoData) => {
      if (
        data &&
        !Array.isArray(data) &&
        typeof data.v === 'object' &&
        !(data.v instanceof Date) &&
        data.v.latitude
      ) {
        this.locations.next([data.v]);
      }
    });
  }

  public init = async () => {};

  public setLocation = async (location: ILocationData) => {
    await this._gizmo.setData({ v: location });
  };

  public getLocations = (): ILocationData[] => {
    const locations: ILocationData[] = [];
    const data = this._gizmo.getData() as IGizmoData;

    if (
      data &&
      !Array.isArray(data) &&
      typeof data.v === 'object' &&
      !(data.v instanceof Date) &&
      data.v.latitude
    ) {
      locations.push(data.v);
    }

    return locations;
  };
}

export default LocationFieldBinder;
